
export const robinReviewerReviewHinge = {
  _id: 'robinReviewerReviewHingeId',
  email: 'robin@email.com',
  profileReviewId: 'robinProfileReviewHingeId',
  reviewerProfileId: 'robinReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Robin! This will really help me!',
  profileReviewedFirstName: 'Ted',
}

export const zoeyReviewerReviewBumble = {
  _id: 'zoeyReviewerReviewBumbleId',
  email: 'zoey@email.com',
  profileReviewId: 'zoeyProfileReviewBumbleId',
  reviewerProfileId: 'zoeyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Zoey! This will really help me!',
  profileReviewedFirstName: 'Ted',
}

export const stellaReviewerReviewTinder = {
  _id: 'stellaReviewerReviewTinderId',
  email: 'stella@email.com',
  profileReviewId: 'stellaProfileReviewTinderId',
  reviewerProfileId: 'stellaReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Stella! This will really help me!',
  profileReviewedFirstName: 'Ted',
}